<template>
    <div id="text-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="moduleData.Background + ' ' + moduleData.Spacing" :id="moduleData.AnchorID">
            <div class="container">
                <div class="top">
                    <h2 v-if="moduleData.Title && moduleData.ShowTitle">{{moduleData.Title}}</h2>
                    <p class="heading" v-if="moduleData.Subtitle">{{moduleData.Subtitle}}</p>
                    <p v-if="moduleData.MainContent" v-html="moduleData.MainContent"></p>
                </div>
                <div class="columns" v-if="moduleData.LeftContent">
                    <div class="left">
                        <p class="heading" v-html="moduleData.LeftTitle" v-if="moduleData.LeftTitle"></p>
                        <p v-html="moduleData.LeftContent"></p>
                    </div>
                    <div class="right" v-if="moduleData.RightContent">
                        <p class="heading" v-html="moduleData.RightTitle" v-if="moduleData.RightTitle"></p>
                        <p v-html="moduleData.RightContent"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "TextElement",
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData', 'getSettings']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            }
        }
    }
</script>
